import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * The original's `snackbar` slice (module 35474). Its action is called with a
 * message and an options object — `setSnackbar(message, { severity,
 * anchorOrigin })` — and the whole app raises its transient messages through
 * it: the delivery-address modal alone has seven.
 *
 * Reproduced rather than invented: without it the address flow's geolocation
 * outcomes had nowhere to surface, and every one of those strings is recovered
 * copy that must appear verbatim.
 */

export type SnackbarSeverity = "success" | "info" | "warning" | "error";

export interface SnackbarAnchor {
  vertical: "top" | "bottom";
  horizontal: "left" | "center" | "right";
}

export interface SnackbarState {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
  anchorOrigin: SnackbarAnchor;
  autoHideDuration: number;
}

const initialState: SnackbarState = {
  open: false,
  message: "",
  severity: "info",
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  autoHideDuration: 4000,
};

export type SnackbarInput = {
  message: string;
  severity?: SnackbarSeverity;
  anchorOrigin?: SnackbarAnchor;
  autoHideDuration?: number;
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setSnackbar(state, action: PayloadAction<SnackbarInput>) {
      return { ...initialState, ...action.payload, open: true };
    },
    closeSnackbar(state) {
      state.open = false;
    },
  },
});

export const { setSnackbar, closeSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
